import React from 'react';

export default function Traction() {
  return (
    <section className="w-full bg-gray-950 text-white py-20 px-6 md:px-10">
      <div className="max-w-6xl mx-auto space-y-14">

        {/* Section Header */}
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Our Traction So Far</h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            M2T is early but real — already showing strong signals across product development, community validation, and investor interest.
          </p>
        </div>

        {/* Traction Highlights */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 text-gray-300 text-base">

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 shadow">
            <h3 className="text-xl text-white font-semibold mb-2">🧪 MVP Almost Ready</h3>
            <p>
              SmartCard login system, role selector, and onboarding flow built in React + Firebase — launching this quarter.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 shadow">
            <h3 className="text-xl text-white font-semibold mb-2">📥 Waitlist Growing</h3>
            <p>
              Targeting 1,000+ early signups from traders, educators, analysts, and regional leaders across 24 countries.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 shadow">
            <h3 className="text-xl text-white font-semibold mb-2">📸 Platform Screenshots</h3>
            <p>
              Role dashboard, signal panel, and SmartCard UX already designed and demo-ready.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 shadow">
            <h3 className="text-xl text-white font-semibold mb-2">📣 Active Social Presence</h3>
            <p>
              Early traction on X (Twitter), Facebook, and financial communities across India and Africa.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 shadow">
            <h3 className="text-xl text-white font-semibold mb-2">💬 Feedback Loop</h3>
            <p>
              Advisors, early users, and platform testers are already shaping onboarding, UI, and monetization priorities.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 shadow">
            <h3 className="text-xl text-white font-semibold mb-2">📨 YC + Angel Outreach</h3>
            <p>
              Engaged with early-stage VCs and angels. YC application submitted with complete traction materials.
            </p>
          </div>

        </div>

        {/* Optional: Add Screenshot Grid or Carousel */}
        <div className="text-center pt-10">
          <p className="text-sm text-gray-500 mb-2">
            Want to see how it looks?
          </p>
          <a
            href="/screenshots"
            className="inline-block bg-purple-600 hover:bg-purple-700 text-white py-3 px-6 rounded-lg font-semibold shadow"
          >
            View Platform Screens
          </a>
        </div>

      </div>
    </section>
  );
}
